import ClassCreate from '@/controllers/class/class-create.js';
import axios from "axios";
import store from '@/store';

export default {
  extends: ClassCreate,

  data() {
    return {
      teacherArr: [],
      homeroom_teacher_id: '',
      assistant_teacher_ids: [],
      selectedHomeroomTeacher: 0,
      selectedAssistantTeachers: [],
    };
  },

  mounted() {
    if (!this.classData.start_date) this.$set(this.classData, 'start_date', null);
    if (!this.classData.end_date) this.$set(this.classData, 'end_date', null);
    this.getAllTeacher();
  },

  computed: {
    dateError() {
      const start = this.classData.start_date;
      const end = this.classData.end_date;
      if (!start || !end) return false;
      const startDate = new Date(start);
      const endDate = new Date(end);
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return false;
      return endDate <= startDate;
    }
  },

  methods: {
    getAllTeacher() {
      axios.get("/teacher/getallTeacher", {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then((response) => {
        this.teacherArr = response.data[0];
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    confirmRegister() {
      if (this.disabled) return;
      this.submitted = true;

      if (this.dateError) {
        this.isError = true;
      } else {
        this.isError = false;
      }

      if (
        this.$v.$invalid ||
        this.grade_id == "" ||
        this.grade_id == 0 ||
        this.academic_year == "" ||
        this.academic_year == 0 ||
        this.section == "" ||
        this.section == 0 ||
        this.homeroom_teacher_id == 0 ||
        this.homeroom_teacher_id == "" ||
        this.dateError
      ) {
        this.validationErrors = {};
        return;
      }

      this.clearValidationErrors();
      this.register();
    },

    register() {
      this.disabled = true;
      var request = {
        grade_id: this.grade_id,
        academic_year: this.academic_year,
        section: this.classData.section,
        remark: this.classData.remark,
        start_date: this.classData.start_date,
        end_date: this.classData.end_date,
        homeroom_teacher_id: this.homeroom_teacher_id == 0 ? null : this.homeroom_teacher_id,
        assistant_teacher_ids: this.assistant_teacher_ids || [],
        campus_id: store.state.user.campus_id,
        login_id: store.state.user.id
      }
      axios.post("/class/create", request, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          if (response.status == 200) {
            this.$notification.success("Class Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            if (this.$route.query.rd_back == 'class') {
              this.$router.push({
                name: "classCreate"
              });
            } else {
              this.$router.push({
                name: "classList"
              });
            }
          }
          else if (response.status == 201) {
            this.isLoading = false;
            this.disabled = false;
            this.$notification.error("Class already exists.", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          if (!this.showTeacherValidationNotifications(error.response)) {
            this.printValidationError(error.response);
          }
          
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.disabled = false;
          console.log("Class Create API Error", error.errors);
        });
    },

    showTeacherValidationNotifications(response) {
      if (!response || response.status !== 422 || !response.data.errors) {
        return false;
      }

      const teacherErrorFields = ['homeroom_teacher_id', 'assistant_teacher_ids'];
      let hasNotificationError = false;

      teacherErrorFields.forEach(field => {
        if (response.data.errors[field]) {
          this.$notification.error(response.data.errors[field][0], {
            timer: 3,
            position: "bottomCenter",
          });
          hasNotificationError = true;
        }
      });

      return hasNotificationError;
    },

    showList() {
      this.$router.push({
        path: "/class/list"
      });
    },
  },
}
